import React from 'react';

const TenantInvitationFormModal = React.lazy(() => import('../components/FormModal'));
const tenantInvitationModalRegistry = {
    core_tenantInvitationId: TenantInvitationFormModal
};
export default tenantInvitationModalRegistry;
